export default "__VITE_ASSET__b22d74fd__"